module.exports = __webpack_public_path__ + "static/podcast-preview-0633f69cd24f10d1b9eb3745b284eabe.svg";